import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginWithEmailComponent } from './login-with-email.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleSigninModule } from '../google-signin-module';
import { GoogleRECAPTCHAModule } from '../google-recaptcha/google-recaptcha.module';
import { CountryPickerModule } from 'src/app/country-picker/country-picker.module';
import { OtpVerificationComponent } from '../otp-verification/otp-verification.component';

@NgModule({
  declarations: [LoginWithEmailComponent, OtpVerificationComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    GoogleSigninModule,
    GoogleRECAPTCHAModule,
    CountryPickerModule,
  ]
})
export class LoginWithEmailModule { }
